module.exports = __webpack_public_path__ + "img/img13.a28fd28c.png";